<template>
  <!-- 人工配送下单弹窗页面 -->
  <div>
    <el-form ref="form" label-position="left" label-width="auto" class="grey padding10">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="销售渠道">
            <p>{{ orderInfo.zplatOrder === 0 ? "美团" : orderInfo.zplatOrder === 1 ? "京东到家" : orderInfo.zplatOrder === 2 ? "饿了么" : "tops" }}</p>
          </el-form-item>
          <el-form-item label="商家实收">
            <p>{{ orderInfo.noriginPrice ? (orderInfo.noriginPrice / 100).toFixed(2) : "0" }}元</p>
          </el-form-item>
          <el-form-item label="订单状态">
            <p :class="[calculateTimeDifferenceInMinutes(orderInfo.tarriveReq).timeDifference > 0 ? 'overdue-time' : 'remaining-time']">
              {{ calculateTimeDifferenceInMinutes(orderInfo.tarriveReq).displayText }}
            </p>
          </el-form-item>
          <el-form-item label="收货地址">
            <p>{{ orderInfo.creceiveAddr }}</p>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预定人">
            <p>{{ orderInfo.ccustomerName }}</p>
          </el-form-item>
          <el-form-item label="手机号码">
            <p>{{ orderInfo.ccustomerPhone }}</p>
          </el-form-item>
          <el-form-item label="用户备注">
            <p>{{ orderInfo.corderRemark }}</p>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="20" style="padding: 0 20px;">
      <el-tabs v-model="tabActive">
        <el-tab-pane :label="'松鼠屋(' + underPrice.ssw + ')'" name="0">
          <deliveryTabSsw :order-info="orderInfo" @handleConfirm="handleConfirm" @handleClose="handleClose" @handleUnderPrice="handleUnderPrice" />
        </el-tab-pane>
        <el-tab-pane :label="'抖送(' + underPrice.ds + ')'" name="1">
          
        </el-tab-pane>
        <el-tab-pane :label="'快服务(' + underPrice.kfw + ')'" name="2">
          <deliveryTabKfw :order-info="orderInfo" @handleConfirm="handleConfirm" @handleClose="handleClose" @handleUnderPrice="handleUnderPrice" />
        </el-tab-pane>
        <el-tab-pane :label="'真省钱(' + underPrice.zsq + ')'" name="3">
          <deliveryTabZsq :order-info="orderInfo" @handleConfirm="handleConfirm" @handleClose="handleClose" @handleUnderPrice="handleUnderPrice" />
        </el-tab-pane>
        <el-tab-pane :label="'美团跑腿(' + underPrice.mtpt + ')'" name="5">
          <deliveryTabMtpt :order-info="orderInfo" @handleConfirm="handleConfirm" @handleClose="handleClose" @handleUnderPrice="handleUnderPrice" />
        </el-tab-pane>
        <el-tab-pane :label="'美团配送(' + underPrice.mtps + ')'" name="6">c</el-tab-pane>
        <el-tab-pane :label="'巨莱昂配送(' + underPrice.jla + ')'" name="7">c</el-tab-pane>
        <el-tab-pane :label="'自配送(' + underPrice.self + ')'" name="8">c</el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import deliveryTabSsw from "./deliveryTab/deliveryTabSsw.vue";
import deliveryTabKfw from "./deliveryTab/deliveryTabKfw.vue";
import deliveryTabMtpt from "./deliveryTab/deliveryTabMtpt.vue";
import deliveryTabZsq from "./deliveryTab/deliveryTabZsq.vue";

export default {
  name: "deliveryOrderDialog",
  components: {
    deliveryTabSsw,
    deliveryTabKfw,
    deliveryTabMtpt,
    deliveryTabZsq,
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabActive: "0",
      underPrice: {
        "ssw": "计算中",
        "ds": "开发中",
        "kfw": "计算中",
        "zsq": "计算中",
        "mtpt": "计算中",
        "mtps": "无法计算",
        "jla": "未启用",
        "self": "0",
      }
    };
  },
  methods: {
    /**
     * 计算超时时间
     * @param targetTime
     * @returns {{displayText: string, timeDifference: number}}
     */
    calculateTimeDifferenceInMinutes(targetTime) {
      let now = new Date();
      let target = new Date(parseInt(targetTime + "000"));
      // 获取两个时间戳之差（毫秒）
      let differenceInMilliseconds = now.getTime() - target.getTime();
      // 转换为分钟，不需要取绝对值，因为我们要保留正负号表示超时还是剩余
      let differenceInMinutes = Math.ceil(differenceInMilliseconds / (1000 * 60));
      return {
        timeDifference: differenceInMinutes,
        displayText: differenceInMinutes > 0 ? `超时 ${differenceInMinutes} 分钟` : `剩余 ${-differenceInMinutes} 分钟`,
      };
    },
    handleUnderPrice(key, value) {
      this.underPrice[key] = value;
      console.log(this.underPrice);
    },
    handleConfirm() {
      this.$emit("handleConfirm");
    },
    handleClose() {
      this.$emit("handleClose");
    }
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-form-item__content {
  display: block;
}

.delivery-platform-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.remaining-time {
  color: green;
}

.overdue-time {
  color: red;
}

.delivery-block {
  height: 70px;
  width: 20%;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.hover-color:hover {
  /* 鼠标悬停时的样式 */
  background-color: rgba(64, 158, 255, 0.21);
}

.active {
  background-color: rgba(64, 158, 255, 0.21);
}
</style>
